/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
   window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, (event) => {
     console.log('Variant changed:', event.data.variant.name);

     const VARIANT_SELECTOR = '[data-single-option-selector]:checked';
     const container = document.querySelector('.selector-wrapper--boxes') || document;
     const checked = container.querySelector(VARIANT_SELECTOR);
      if (!checked) return;

      const isPreorder = checked.dataset.isPreorder || '';
      const nextStockDate = checked.dataset.nextStockDate || '';
      const addToCartButton = document.querySelector('[data-add-to-cart]');
      if (isPreorder == 'true') {
         if (addToCartButton) {
            const buttonText = addToCartButton.querySelector('[data-atc-button-text]');
            if (buttonText) {
              buttonText.textContent = window.theme.strings.preorder;
            }
         }
      }

      const wrapper = document.querySelector('.selector-wrapper--stock-text');
      const preorderContainer = wrapper?.querySelector('.stock-date-text');

      if (!wrapper || !preorderContainer) return;
      if (nextStockDate) {
        preorderContainer.textContent = nextStockDate;
        wrapper.style.display = 'inline-block';
      } else {
        preorderContainer.textContent = '';
        wrapper.style.display = 'none';
      }
    });
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
